export const actionTypes = {
  EVENTS_BY_YEAR_START: 'APP.CALENDAR_EVENTS.EVENTS_BY_YEAR_START!',
  EVENTS_BY_YEAR_SUCCESS: 'APP.CALENDAR_EVENTS.EVENTS_BY_YEAR_SUCCESS',
  EVENTS_BY_YEAR_FAILURE: 'APP.CALENDAR_EVENTS.EVENTS_BY_YEAR_FAILURE',

  YEARS_LIST_START: 'APP.CALENDAR_EVENTS.YEARS_LIST_START',
  YEARS_LIST_SUCCESS: 'APP.CALENDAR_EVENTS.YEARS_LIST_SUCCESS',
  YEARS_LIST_FAILURE: 'APP.CALENDAR_EVENTS.YEARS_LIST_FAILURE',
};

export function fetchCalendarEventsByYear(year) {
  return {
    type: actionTypes.EVENTS_BY_YEAR_START,
    payload: year,
  };
}

export function fetchCalendarEventsSuccess(data) {
  return {
    type: actionTypes.EVENTS_BY_YEAR_SUCCESS,
    payload: data,
  };
}

export function fetchCalendarEventsFailure(error) {
  return {
    type: actionTypes.EVENTS_BY_YEAR_FAILURE,
    payload: error,
  };
}

export function fetchCalendarYears() {
  return {
    type: actionTypes.YEARS_LIST_START,
  };
}

export function fetchCalendarYearsSuccess(data) {
  return {
    type: actionTypes.YEARS_LIST_SUCCESS,
    payload: data,
  };
}

export function fetchCalendarYearsFailure(error) {
  return {
    type: actionTypes.YEARS_LIST_FAILURE,
    payload: error,
  };
}
